module.exports = __webpack_public_path__ + "files/capitis2021.7c5b539d954efa95f4ce9ed359d1cb46.pdf";